/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileCard_delegate = {
    readonly email: string | null;
    readonly TTC_ID: string;
    readonly jobTitle: string;
    readonly telephone: string | null;
    readonly " $refType": "ProfileCard_delegate";
};
export type ProfileCard_delegate$data = ProfileCard_delegate;
export type ProfileCard_delegate$key = {
    readonly " $data"?: ProfileCard_delegate$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileCard_delegate">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ProfileCard_delegate",
    "type": "Delegate",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "TTC_ID",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "jobTitle",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "telephone",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'c2633e3e62e2137cddb4a3e035fa3a1c';
export default node;
